export default __webpack_public_path__ + "static/media/clawsoflife.e81bdc32.png";